import styled from "styled-components";

export const ActionsWrapper = styled.div`
  width: 138px;
  display: flex;
  flex-direction: row;
  gap: 12px;
  justify-content: center;
  align-items: flex-end;
  padding-right: 0.5rem;
  padding-left: 1rem;

  @media ${(props) => props.theme.device.md} {             
    margin-right: 2rem;     
  }

  a {
    margin-bottom: 3px;
  }
`;

export const LabelWrapper = styled.div`
  width: 20%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
`;

export const IconWrapper = styled.div`  
  margin: auto;  
`;

export const BpmWrapper = styled.div`
  width: 20%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
`;

export const GenreWrapper = styled.div`
  width: 20%;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
`;

export const Artists = styled.div``;

export const MixName = styled.span``;

export const TrackName = styled.span`
  color: ${(props) => props.theme.colors.neutrals.primary.white};
`;

export const NameWrapper = styled.div`
  width: 100%;
  padding-left: 8px;
  @media ${(props) => props.theme.device.md} {
    width: 45%;
  }
`;

export const PlaylistItem = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

  font-family: ${(props) => props.theme.fonts.aeonik};
  font-style: normal;
  font-weight: 400;
  font-size: 11px;
  line-height: 16px;
  letter-spacing: 0.005em;

  .track-play-overlay {
    display: flex;
    width: 44px;
    min-width: 44px;
    height: 44px;
    margin-left: -3rem;
    justify-content: center;
    align-items: center;
    pointer-events: none;

    svg {
      display: none;
    }
  }

  color: ${(props) => props.theme.colors.neutrals.primary.graytext};

  &:hover {
    background: ${(props) =>
		props.theme.colors.neutrals.secondary.gray.divider1};

    a span {
      color: ${(props) => props.theme.colors.green[300].accent};
    }

    .track-play-overlay {
      background: rgba(0, 0, 0, 0.2);

      svg {
        display: block;
      }
    }
  }

  a:hover,
  a:hover span {
    color: ${(props) => props.theme.colors.green[300].accent};
  }

  &.current {
    background: ${(props) => props.theme.colors.neutrals.secondary.gray.active};

    a span.track-name {
      color: ${(props) => props.theme.colors.green[300].accent};
    }

    img.cover {
      border-left: 3px solid ${(props) => props.theme.colors.green[300].accent};
    }
  }

  img.cover {
    cursor: pointer;
  }
`;

export const PlaylistContainer = styled.div`
  width: 100%;
  height: 50vh;
  overflow: auto;
  padding-top: 0.5rem;
  position: relative;
  margin-top: 20px;

  @media ${(props) => props.theme.device.md} {
    height: 226px;
  }
`;

export const ClearBox = styled.div`
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: flex-end;

  text-align: center;
  font-family: ${(props) => props.theme.fonts.aeonik};
  font-style: normal;
  font-weight: 400;
  font-size: 11px;
  line-height: 16px;
  letter-spacing: -0.015em;

  color: ${(props) => props.theme.colors.neutrals.primary.graytext};

  background: linear-gradient(45deg, transparent 2rem, #000 0);
  cursor: pointer;
  transition: color 0.2s;

  padding-left: 30px;
  padding-right: 10px;
  width: 124px;
  height: 20px;
  right: 0;
  top: 0;
  z-index: 5;

  &:hover {
    color: ${(props) => props.theme.colors.neutrals.primary.white};
  }
`;

export const Wrapper = styled.div`
  position: relative;
  width: 100%;
  flex: 0 0 50vh;
  background: ${(props) => props.theme.colors.neutrals.primary[900]};
  overflow: hidden;
  transition: flex 0.25s, -webkit-flex 0.25s;
  @media ${(props) => props.theme.device.md} {
    flex: 0 0 246px;
  }
`;
